import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { isAfter, parse } from 'date-fns';
import get from 'lodash/get';

import { BasicConfigService } from '@core/service/basicConfig.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RequestInterceptor } from './interceptor/request.interceptor';
import { ResponseInterceptor } from './interceptor/response.interceptor';
import { StartupService } from './service';

@NgModule({
  providers: [
    StartupService,
    BasicConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (startupService: StartupService, myInitService: BasicConfigService) => async () => {
        const hash = window.location.hash;
        await myInitService.initConfig();
        const showMove: boolean = myInitService.get('showMove');
        if (
          showMove ||
          hash.includes('passport/ssologin') ||
          hash.includes('passport/oalogin') ||
          hash.includes('exception/forbidden')
        )
          return;
        return startupService.load();
      },
      deps: [StartupService, BasicConfigService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`CoreModule has already been loaded. Import Core modules in the AppModule only.`);
    }
  }
}
